﻿//strongly inspired by https://stackoverflow.com/questions/45834446/making-a-ngb-draggable-modal


import { Directive, ElementRef, Input, OnInit, OnDestroy, NgZone, Renderer2, HostListener, HostBinding } from '@angular/core';

class Position {
    x: number; y: number;
    constructor(x, y) { this.x = x; this.y = y; }
};


@Directive({
    selector: '[draggable]'
})
export class DraggableDirective implements OnInit, OnDestroy {

    // #region properties

    /**
    * optional => specify the element selector (.class name or #id ) to drag. Must be a parent of the current element
    * If not set, the element on which the draggable directive is applied will be used as host
    */
    @Input('drag-container') public dragContainer: string;

    private handle: HTMLElement;
    private host: HTMLElement;

    private allowDrag = true;
    private moving = false;
    private origin = null;

    // for adding / detaching mouse listeners dynamically so they're not *always* listening
    private unsubscribeMouseMove: Function;
    private unsubscribeMouseUp: Function;


    // #endregion

    // #region ctor

    constructor(private el: ElementRef, private zone: NgZone, private renderer: Renderer2) {
    }

    // #endregion

    // #region angular event cycle

    ngOnInit() {

        if (this.el) {
            this.handle = this.el.nativeElement;
            this.host = this.getHostElement();

            if (this.host)
                this.handle.classList.add('draggable');


            // applies mousemove and mouseup listeners to the parent component, typically my app componennt window, I prefer doing it like this so I'm not binding to a window or document object

            this.unsubscribeMouseUp = this.renderer.listen(this.host, 'mouseup', () => {
                this.moving = false;
                this.host.classList.remove('dragging');
            });

            // uses ngzone to run moving outside angular for better performance
            this.unsubscribeMouseMove = this.renderer.listen(this.host, 'mousemove', ($event) => {
                if (this.moving && this.allowDrag) {
                    this.zone.runOutsideAngular(() => {
                        event.preventDefault();
                        this.moveTo($event.clientX, $event.clientY);
                    });
                }
            });
        }

    }

    ngOnDestroy() {

        if (this.host)
            this.handle.classList.remove('draggable');

        if (this.unsubscribeMouseUp)
            this.unsubscribeMouseUp();

        if (this.unsubscribeMouseMove)
            this.unsubscribeMouseMove();
    }

    // #endregion

    // #region private methods

    private getHostElement = () => {

        if (this.dragContainer)
            return this.findHostElement(this.dragContainer, this.handle);
        else
            return this.handle;
    }

    private findHostElement = (target: string, elem: HTMLElement) => {

        if (!elem)
            return null;

        if (target.startsWith('#') && elem.id == target.replace('#', ''))
            return elem;

        if (target.startsWith('.') && elem.classList.contains(target.replace('.', '')))
            return elem;

        return this.findHostElement(target, elem.parentElement);

    }



    // parses css translate string for exact px position
    private getPosition(x: number, y: number): Position {

        let transform = this.host.style.transform;
        if (transform) {
            let transVal: string[] = transform.split(',');
            let newX = parseInt(transVal[0].replace('translate(', ''));
            let newY = parseInt(transVal[1]);
            return new Position(x - newX, y - newY);
        }

        return new Position(x, y);
    }

    private moveTo(x: number, y: number): void {

        if (this.origin)
            this.host.style.transform = `translate(${x - this.origin.x}px, ${y - this.origin.y}px)`;
    }

    @HostListener('mousedown', ['$event'])
    onMouseDown(event: MouseEvent) {
        if (event.button == 2 || (this.handle !== undefined && event.target !== this.handle) || (!this.host)) {
            return;
        }
        else {
            this.moving = true;
            this.host.classList.add('dragging');
            this.origin = this.getPosition(event.clientX, event.clientY);
        }
    }



    // #endregion
}